import { Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Flex, Link, useColorMode, Stack } from "@chakra-ui/react";
import React, {useEffect, useState} from "react";
import NavbarLinks from "./NavbarLinks";
import theme from "../assets/themes/theme";
import { ThemeProvider } from '@mui/material';
import Sidebar from "./Sidebar";
import LogoSTL from '../assets/images/LogoSTL.svg';
import LogoAxsis from '../assets/images/logoAxsis.png';
import logoLolify from "../assets/images/Lilofy_color.png";

export default function Navbar(props) {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        window.addEventListener("scroll", changeNavbar);

        return() => {
            window.removeEventListener("scroll", changeNavbar);
        }
    });

    const changeNavbar = () => {
        if(window.scrollY > 1){
            setScrolled(true);
        }else{
            setScrolled(false);
        }
    };

    const getDash = (routes) => {
        if(routes?.length > 0) return routes[0].layout + '/Home';
        else return ''
    };

    const { colorMode } = useColorMode();

    const {
        variant,
        children,
        fixed,
        secondary,
        brandText,
        onOpen,
        routes,
        ...rest
    } = props;

    //Props
    let mainText = (fixed && scrolled) ? "gray" : "white";
    let secondaryText = (fixed && scrolled) ? "gray" : "white";
    let navbarPosition = "absolute";
    let navbarFilter = "none";
    let navbarBackdrop = "none";
    let navbarShadow = "none";
    let navbarBg = "#1E87FF";
    let navbarBorder = "transparent";
    let secondaryMargin = "0px";
    let navbarIcon = fixed && scrolled ? "gray" : "white";

    if(props.fixed === true){
        if (scrolled === true){
            navbarPosition = "fixed";
            navbarShadow = "0px 7px 23px rgba(0,0,0,0.05)";
            navbarBg = "linear-gradient(112.83deg, rgba(255, 255, 255, 0.82) 0%, rgba(255, 255, 255, 0.8) 110.84%)";
            navbarBorder = "#FFF";
            navbarFilter = "none";
        }
    }

    return(
        <ThemeProvider theme={theme}>
            <Flex
                position={navbarPosition}
                boxShadow={navbarShadow}
                bg={navbarBg}
                borderColor={navbarBorder}
                filter={navbarFilter}
                backdropFilter={navbarBackdrop}
                borderWidth="1.5px"
                borderStyle="solid"
                transitionDelay="0s, 0s, 0s, 0s"
                transitionDuration="0.25s, 0.25s, 0.25s, 0s"
                transitionProperty="box-shadow, background-color, filter, border"
                transitionTimingFunction="linear linear linear linear"
                alignItems={{xl: "center"}}
                display="flex"
                justifyContent={{xl: "center"}}
                lineHeight="25.6px"
                mx="auto"
                mt={secondaryMargin}
                pb="8px"
                pr="30px"
                pl="12px"
                pt="8px"
                top="0px"
                w="100%">
                    <Flex
                        w="100%"
                        flexDirection={{sm: "column", md: "row"}}
                        alignItems={{xl: "center"}}>
                            <Sidebar
                                hamburguerColor={navbarIcon}
                                logo={
                                    <Stack direction="column" align="center" justify="center"  px={"10px"}>
                                        <Box w="8rem">
                                            <img src={LogoSTL} alt="logo" />
                                        </Box>
                                    </Stack>
                                }
                                logoAxsis={
                                    <Stack direction="column" align="center" justify="center"  px={"10px"}>
                                        <Box w="8rem">
                                            <img src={logoLolify} alt="logoAxsis" />
                                        </Box>
                                    </Stack>
                                }
                                colorMode={colorMode}
                                routes={routes}
                                {...rest}
                            />
                            <Box mb={{sm: "8px", md: "0px"}} display="flex" alignItems={"center"} ml={4}>
                                <Breadcrumb>
                                    <BreadcrumbItem color={mainText}>
                                        <BreadcrumbLink color={secondaryText} href={getDash(routes)}>
                                            Inicio
                                        </BreadcrumbLink>
                                    </BreadcrumbItem>

                                    <BreadcrumbItem color={mainText}>
                                        <BreadcrumbLink color={secondaryText} className="breadLinks">
                                            {brandText}
                                        </BreadcrumbLink>
                                    </BreadcrumbItem>
                                </Breadcrumb>
                            </Box>
                            <Box ms="auto" w={{sm: "100%", md: "unset"}}>
                                <NavbarLinks
                                    onOpen={props.onOpen}
                                    logoText={props.logoText}
                                    fixed={props.fixed}
                                    scrolled={scrolled}
                                    routes={routes}/>
                            </Box>
                    </Flex>
            </Flex>

        </ThemeProvider>
    );
}